export default "__VITE_ASSET__5A0DfUox__"